"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import { v4 } from "uuid";
export class Controller {
  constructor() {
    this._hash = v4();
  }
  get hash() {
    return this._hash;
  }
  refresh() {
    this._hash = v4();
  }
}
let MainView = class extends Vue {
  refresh() {
    this._controller.refresh();
  }
};
__decorateClass([
  PropSync("controller", {
    default: () => {
      return new Controller();
    }
  })
], MainView.prototype, "_controller", 2);
MainView = __decorateClass([
  Component({})
], MainView);
export {
  MainView as default
};
